import React from "react";
import "./Publications.css";

// import { FaFilePdf, FaCode, FaLink } from "react-icons/fa";
import { FaFileAlt, FaFilePdf, FaGithub, FaLink, FaVideo } from "react-icons/fa";
import logo_ECCV from "../assets/logos/ECCV.svg";
import logo_MIRU2024 from "../assets/logos/MIRU2024.png";
import logo_DUT from "../assets/logos/DUT.png";
import logo_ScienceScope from "../assets/logos/ScienceScope.jpg";

const BOLD_NAMES = ["Taïga Gonçalves", "Taïga Nakajima"];

const publicationsData = {
  "International Conferences": [
    {
      image: logo_ECCV,
      title:
        "Improving Adversarial Robustness via Activation Amplification and Attenuation",
      authors: "Taïga Gonçalves, Yongsong Huang, Tomo Miyazaki, Shinichiro Omachi",
      venue:
        "In Proceedings of the European Conference on Computer Vision (ECCV)",
      year: 2026,
      links: [
        {
          label: "Paper",
          url: "https://arxiv.org/abs/2606.27784",
          icon: <FaFileAlt className="link-icon" />,
        },
        {
          label: "Code",
          url: "https://github.com/tgoncalv/A3",
          icon: <FaGithub className="link-icon" />,
        },
      ],
      borderless: true,
    },
  ],
  "International Workshops": [
    {
      image: logo_DUT,
      title:
        "Feature Amplification Generator for Multi-Targeted Adversarial Attacks",
      presentation: "(Oral Presentation)",
      authors: "Taïga Gonçalves, Tomo Miyazaki, Shinichiro Omachi",
      venue:
        "In International Workshop on Emerging Information and Communication Technology (IWEICT)",
      year: 2024,
      links: [
        {
          label: "Link",
          url: "https://iweict2024.dlut.edu.cn/Meeting/Default/Index_En?mid=76521e1f-b31f-486f-9ef6-5757899301ba",
          icon: <FaLink className="link-icon" />,
        },
        // { label: "Code", url: "https://example.com/code", icon: <FaCode className="link-icon" /> },
      ],
      // note: "",
      borderless: true, // Set true to remove the border
    },
  ],
  "Domestic Conferences": [
    {
      image: logo_MIRU2024,
      title:
        "Cross-Domain Multi-Targeted Adversarial Attacks by Learning Spatial Features",
      presentation: "(Oral Presentation)",
      authors: "Taïga Gonçalves, Tomo Miyazaki, Shinichiro Omachi",
      venue: "In Meeting on Image Recognition and Understanding (MIRU)",
      year: 2025,
      links: [
        {
          label: "Link",
          url: "https://cvim.ipsj.or.jp/MIRU2025/award.html",
          icon: <FaLink className="link-icon" />,
        },
      ],
      borderless: true,
      note: "*Audience Award & Student Encouragement Award",
    },
    {
      image: logo_ScienceScope,
      title:
        "Attaque de Réseaux de Neurones aux Paramètres et Données d’Entraînement Inconnus",
      presentation: "(Oral Presentation)",
      authors: "Taïga Gonçalves, Tomo Miyazaki, Shinichiro Omachi",
      venue: "Journée Francophone de la Recherche (JFR)",
      year: 2024,
      links: [
        {
          label: "Link",
          url: "https://www.sciencescope.org/jfr-2024/",
          icon: <FaLink className="link-icon" />,
        },
        {
          label: "PDF",
          url: "https://www.sciencescope.org/wp-content/uploads/2024/10/Programme-complet-JFR-2024.pdf",
          icon: <FaFilePdf className="link-icon" />,
        },
        {
          label: "Video",
          url: "https://www.youtube.com/watch?v=8l-70eSnsJc",
          icon: <FaVideo className="video-icon" />,
        },
      ],
      borderless: true,
    },
    {
      image: logo_MIRU2024,
      title:
        "Domain Generalizable Multi-Targeted Adversarial Attack using Dynamic Loss Weighting",
      authors: "Taïga Gonçalves, Tomo Miyazaki, Shinichiro Omachi",
      venue: "In Meeting on Image Recognition and Understanding (MIRU)",
      year: 2024,
      links: [
        {
          label: "Link",
          url: "https://miru-committee.github.io/miru2024/en/",
          icon: <FaLink className="link-icon" />,
        },
      ],
      borderless: true,
      note: "*Interactive Presentation Award",
    },
  ],
};

const Publications = () => {
  const formatAuthors = (authors) => {
    return authors.split(", ").map((author, index) => {
      if (BOLD_NAMES.includes(author.trim())) {
        return (
          <strong key={index}>
            {author}
            {index < authors.split(", ").length - 1 ? ", " : ""}
          </strong>
        );
      }
      return author + (index < authors.split(", ").length - 1 ? ", " : "");
    });
  };

  return (
    <section id="publications" className="publications-section">
      <h2>Publications</h2>
      {Object.keys(publicationsData).map((subsection, index) => (
        <div key={index} className="publication-subsection">
          <h3>{subsection}</h3>
          {publicationsData[subsection].map((pub, pubIndex) => (
            <div className="publication-card" key={pubIndex}>
              {/* Conditional rendering for the image */}
              {pub.image && (
                <div
                  className={`publication-image ${
                    pub.borderless ? "borderless" : ""
                  }`}
                >
                  <img src={pub.image} alt={pub.title} />
                </div>
              )}

              {/* Details Section */}
              <div
                className={`publication-details ${
                  !pub.image ? "no-image" : ""
                }`} // Add a class when no image is present
              >
                <h4>{pub.title}</h4>
                {pub.presentation && (
                  <p className="presentation-type">{pub.presentation}</p>
                )}
                <p className="authors">{formatAuthors(pub.authors)}</p>
                <p className="venue">
                  {pub.venue}, {pub.year}
                </p>
                <div className="links">
                  {pub.links.map((link, linkIndex) => (
                    <a
                      key={linkIndex}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="about-button"
                    >
                      <span className="button-icon">{link.icon}</span>{" "}
                      {link.label}
                    </a>
                  ))}
                </div>
                {/* Note Section */}
                {pub.note && <p className="note">{pub.note}</p>}
              </div>
            </div>
          ))}
        </div>
      ))}
    </section>
  );
};

export default Publications;
